import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/editorial/footer-hero.png")